export default "__VITE_ASSET__ca840bee__"